import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var Long = /*#__PURE__*/function () {
  function Long(high, low) {
    _classCallCheck(this, Long);
    this.low = low || 0;
    this.high = high || 0;
  }
  _createClass(Long, null, [{
    key: "toBinaryString",
    value: function toBinaryString(i) {
      var mask;
      var result = '';
      for (mask = 0x80000000; mask > 0; mask >>>= 1) result += (i.high & mask) === mask ? '1' : '0';
      for (mask = 0x80000000; mask > 0; mask >>>= 1) result += (i.low & mask) === mask ? '1' : '0';
      return result;
    }
  }]);
  return Long;
}();
export { Long as default };